import { ReactElement } from 'react'

import { Flex } from 'components/core'

import CreateCampaignNegativeKeywordFormAllRow from './CreateCampaignNegativeKeywordFormAllRow'
import CreateCampaignNegativeKeywordFormHeader from './CreateCampaignNegativeKeywordFormHeader'
import CreateCampaignNegativeKeywordFormRow from './CreateCampaignNegativeKeywordFormRow'
import { KeywordField } from './localTypes'
import * as styles from './styles.scss'

interface Props {
    keywords: KeywordField[]
    remove: (index: number) => void
    setFieldValue: (name: string, values: any) => void
}

const CreateCampaignNegativeKeywordForm = ({
    keywords = [],
    remove,
    setFieldValue,
}: Props): ReactElement => {
    return (
        <Flex
            direction="column"
            marginTop={8}
            style={{ flexShrink: 0 }}
            alignItems="normal"
        >
            {keywords.length > 0 ? (
                <div>
                    <CreateCampaignNegativeKeywordFormHeader />
                    <CreateCampaignNegativeKeywordFormAllRow
                        keywords={keywords}
                        setFieldValue={setFieldValue}
                    />
                    {keywords.map((keyword, idx) => (
                        <CreateCampaignNegativeKeywordFormRow
                            key={idx}
                            keyword={keyword}
                            keywordIndex={idx}
                            remove={remove}
                        />
                    ))}
                </div>
            ) : (
                <div
                    className={styles['empty-table-text']}
                    style={{ marginTop: 8, padding: 12 }}
                >
                    To get started, add some negative keywords in the field
                    above
                </div>
            )}
        </Flex>
    )
}

export default CreateCampaignNegativeKeywordForm
